import { render, staticRenderFns } from "./BetslipAreaA.vue?vue&type=template&id=e0c86074"
import script from "./BetslipAreaA.vue?vue&type=script&lang=js"
export * from "./BetslipAreaA.vue?vue&type=script&lang=js"
import style0 from "./BetslipAreaA.vue?vue&type=style&index=0&id=e0c86074&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports